import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-parent-ai-assistant-meta-row',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './parent-ai-assistant-meta-row.component.html',
  styleUrl: './parent-ai-assistant-meta-row.component.scss',
})
export class ParentAiAssistantMetaRowComponent {}
